import { useEffect, useState } from "react"

import { useIsFetching } from "@tanstack/react-query"

import { useI18n } from "@/i18n/use-i18n"

import { GlobalQueryLoadingBar } from "./loading-bar"
import { hasActiveQueries, scheduleLoadingIndicator } from "./loading-state"

export function GlobalQueryLoadingIndicator() {
  const { t } = useI18n()
  const fetchingCount = useIsFetching()
  const active = hasActiveQueries(fetchingCount)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!active) {
      setVisible(false)
      return
    }

    return scheduleLoadingIndicator(setVisible)
  }, [active])

  return (
    <GlobalQueryLoadingBar
      visible={visible}
      label={t("app.loadingCachedData")}
    />
  )
}
